// frontend/src/pages/About.js
import React from 'react';

const About = () => {
    return (
        <div className="container">
            <h2>Our Mission</h2>
            <p>
                Unfamiliar Learning is dedicated to transforming education through mindfulness, emotional alignment, and creativity. Our curriculum goes beyond traditional teaching methods, nurturing mental well-being and self-discovery from an early age.
            </p>

            <h2>Why It Matters</h2>
            <p>
                In today’s fast-paced world, children face countless distractions. Our mission is to empower them to focus, connect with their inner selves, and build a future rooted in peace, purpose, and resilience.
            </p>

            <h2>Join Our Movement</h2>
            <p>
                Whether you're a parent, educator, or supporter, we invite you to join us in creating a new era of education where children grow with confidence, clarity, and compassion.
            </p>

            <h2>Contact Us</h2>
            <p>
                Have questions? Send us an email at <a href="mailto:contact@unfamiliarlearning.org" style={{ fontWeight: 'bold', color: '#006400' }}>contact@unfamiliarlearning.org</a>.
            </p>
        </div>
    );
};

export default About;